import { useQuery } from '@tanstack/react-query';

import { adminFetch } from '@/hooks/admin/useAdminApi';

export interface GroupStore {
  customer_id: string;
  qbo_customer_id: number;
  name: string;
  is_master: boolean;
  open_balance: number;
  open_invoices: number;
  past_due: number;
  last_order_at: string | null;
}

export interface GroupOverviewGroup {
  master: {
    customer_id: string;
    name: string;
    group_kind: 'chain' | 'franchise';
    group_brand: string | null;
  };
  stores: GroupStore[];
}

/**
 * The customer-facing "all my stores" rollup. Only returns data for users
 * who belong to a chain/franchise group MASTER account (e.g. the Keystone
 * Foods people see every Starbird store they have access to, with live
 * open balances). Everyone else gets an empty list — the /stores nav entry
 * hides itself on that.
 */
export function useGroupOverview() {
  return useQuery({
    queryKey: ['group-overview'],
    queryFn: () => adminFetch<{ groups: GroupOverviewGroup[] }>('group-overview'),
    staleTime: 60_000,
    retry: 1,
  });
}
